<script>
    export default {
        name: "AlignmentMixin",
        data () {
            return {
                alignmentOptions : {
                    left : {
                        icon :  imagePath + "/author/images/formatingMenu/justifyleft.png",
                        label : "Left",
                        styleClass : "learnworlds-align-left",
                        flexStyleClass : "justify-flex-start"
                    },
                    center: {
                        icon : imagePath + "/author/images/formatingMenu/justifycenter.png",
                        label : "Center",
                        styleClass : "learnworlds-align-center",
                        flexStyleClass : "justify-center"
                    },
                    right: {
                        icon : imagePath + "/author/images/formatingMenu/justifyright.png",
                        label : "Right",
                        styleClass : "learnworlds-align-right",
                        flexStyleClass : "justify-flex-end"
                    },
                }
            }
        },
        mounted () {
            if (this.myData) {
                // Adding watcher on myData after myData is created.
                // If watcher is set on instantiation, it asks for myData before handleRegistration finishes.
                // At that point sectionId is not set yet, so sectionData returns an empty object.
                this.$watch('myData.responsiveAlignmentClass', function (oldData, newData) {
                    if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                        return;
                    }
                    const responsiveAlignmentClass = newData;
                    if (responsiveAlignmentClass && responsiveAlignmentClass[this.activeDevicePreview]) {
                        this.updateAlignmentClass(responsiveAlignmentClass[this.activeDevicePreview]);
                    }
                }, {deep: true});
            }
            // push responsive functions to nodeState
            this.responsiveFunctions.push('updateAlignmentClassForDevice');
        },
        computed : {
            getAlignmentOptions () {
                return this.alignmentOptions;
            },
            allOptionClasses () {
                let classes = [];

                for (let key in this.alignmentOptions) {
                    if (!this.alignmentOptions.hasOwnProperty(key)) {
                        continue;
                    }

                    classes.push(this.alignmentOptions[key].styleClass);

                    if (this.myNode && this.myNodeType === "column-wrapper") {
                        classes.push(this.alignmentOptions[key].flexStyleClass);
                    }
                }

                return classes;
            },
        },
        methods: {
            getAlignment () {

                let valueToClassMap = Object.keys(this.alignmentOptions).reduce( ( accum , key ) => {
                    let currentIndexData = this.alignmentOptions[key];
                    accum[key] = currentIndexData.styleClass;
                    return accum;
                },{});

                let valueFromClass = this.getKeyForMatchingClass(valueToClassMap,{defaultValue : ""});
                let valueFromCss = this.getStyleProperty("text-align",{defaultValue:""});

                if (valueFromClass) {
                    return valueFromClass;
                } else if ( valueFromCss && valueFromCss !== 'start') {
                    return valueFromCss;
                } else {
                    return "left";
                }
            },
            setAlignment (optionKey) {                
                let responsiveAlignmentClass = this.myData.responsiveAlignmentClass;
                if (!responsiveAlignmentClass['desktop']) {
                    responsiveAlignmentClass['desktop'] = this.alignmentOptions[this.getAlignment()].styleClass;
                }
                let alignmentClass = this.alignmentOptions[optionKey].styleClass;

                if (this.myNode && this.myNodeType === "column-wrapper") {
                    alignmentClass = [alignmentClass];
                    alignmentClass.push(this.alignmentOptions[optionKey].flexStyleClass);
                }
                responsiveAlignmentClass[this.activeDevicePreview] = alignmentClass;
                this.changeMyData({responsiveAlignmentClass});

            },
            updateAlignmentClassForDevice (device, node) {                
                const responsiveAlignmentClass = this.myData.responsiveAlignmentClass;

                if (responsiveAlignmentClass) {
                    let newClass = false;
                    // new class is device specific class, or desktop device class if it is defined else keep the existing class
                    if (responsiveAlignmentClass[device]) {
                        newClass = responsiveAlignmentClass[device];
                    } else if (responsiveAlignmentClass['desktop']) {
                        newClass = responsiveAlignmentClass['desktop'];
                    }
                    if (newClass) {
                        //console.log(`Applying class: ${newClass} for device: ${device} at node: ${node}`)
                        this.updateAlignmentClass(newClass, node);
                    }
                }
            },
            updateAlignmentClass (newClass, node) {
                let data = {
                    newClass : newClass,
                    classesToRemove : this.allOptionClasses,
                    update : true
                }
                this.applyClass(data, node);
            }
        },
        watch: {
            activeDevicePreview: {
                handler () {
                    this.updateAlignmentClassForDevice(this.activeDevicePreview);
                }
            }
        },
    }
</script>

